import React, { useState, useEffect } from 'react';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const slides = [
    {
      title: "Namaste 🙏",
      description: "Welcome to Innovative Eco Krishi Company Limited.",
      image: "/assets/images/heros1.jpeg",
      buttonText: "Learn More",
      buttonLink: "/about"
    },
    {
      title: "Sustainable Farming Solutions",
      description: "Eco-friendly practices for a better tomorrow",
      image: "/assets/images/heros2.jpeg",
      buttonText: "About Our Company",
      buttonLink: "/about"
    },
    {
      title: "Join Our Mission",
      description: "Be part of the agricultural transformation",
      image: "/assets/images/heros.jpeg",
      buttonText: "Contact Us",
      buttonLink: "/contact"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      clearInterval(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, [slides.length]);

  const isMobile = windowWidth < 768;
  const aspectRatio = isMobile ? '56.25%' : '32.26%';

  return (
    <div className="relative w-full overflow-hidden bg-gray-900">
      <div
        className="relative w-full"
        style={{ paddingTop: aspectRatio }}
      >
        <div className="absolute inset-0">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
            >
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                <div className="absolute inset-0 bg-black/50" />
              </div>

              <div className="relative h-full flex items-center justify-center">
                <div className="text-center text-white px-4 max-w-5xl mx-auto">
                  <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 animate-fade-in">
                    {slide.title}
                  </h1>
                  <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 animate-fade-in-up">
                    {slide.description}
                  </p>
                  {index === currentSlide && (
                    <a
                      href={slide.buttonLink}
                      className="inline-block bg-[#1A8D32] hover:bg-[#1E4C9A] text-white font-bold py-2 px-6 sm:py-3 sm:px-8 rounded-lg transition-colors duration-300 animate-fade-in-up"
                    >
                      {slide.buttonText}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}

          <div className="absolute bottom-4 sm:bottom-8 left-0 right-0 flex justify-center space-x-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-colors duration-300 ${index === currentSlide ? 'bg-white' : 'bg-white/50'
                  }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          <button
            onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
            className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 text-white hover:text-[#1A8D32] transition-colors duration-300"
            aria-label="Previous slide"
          >
            <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
            className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-white hover:text-[#1A8D32] transition-colors duration-300"
            aria-label="Next slide"
          >
            <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider; 